export default __webpack_public_path__ + "static/media/mobileCrane.11ba63e5.jpg";